import { useTooltip, TooltipContent } from "@/components/Tooltip";

export function useLiveboardTooltip<T extends HTMLElement>(
  content: TooltipContent,
  delay: number = 1000,
) {
  return useTooltip<T>(content, {
    delay,
    position: (rect) => ({
      x: rect.right - 0.93 * rect.width,
      y: rect.top - 2.8 * rect.height,
    }),
  });
}
